import { CalendarClock, ChevronRight, DollarSign, MapPin, PackageCheck } from "lucide-react";
import StatusPill from "../components/StatusPill";
import { DELIVERY_STATUS_META, FULFILLMENT_STATUS_META, ORDER_STATUS_META, PAYMENT_STATUS_META, PRIORITY_META, dateText, meta, money } from "./orderStatusMeta";

export default function OrderCard({ order, onOpen }) {
  const tones = order.status_tones || {};
  const orderMeta = meta(ORDER_STATUS_META, order.status, order.status_label);
  const paymentMeta = meta(PAYMENT_STATUS_META, order.payment_status, order.payment_status_label);
  const fulfillMeta = meta(FULFILLMENT_STATUS_META, order.fulfillment_status, order.fulfillment_status_label);
  const deliveryMeta = meta(DELIVERY_STATUS_META, order.delivery_status, order.delivery_status_label);
  const priorityMeta = meta(PRIORITY_META, order.priority, order.priority_label);

  return (
    <article className="order-card">
      <header className="order-card__header">
        <button type="button" className="order-card__identity" onClick={() => onOpen(order)}>
          <span>{order.order_number}</span>
          <strong>{order.customer_name_snapshot || "Guest customer"}</strong>
          <small>{order.customer_email_snapshot || order.customer_phone_snapshot || "No contact snapshot"}</small>
        </button>
        <button type="button" className="order-card__open" onClick={() => onOpen(order)} aria-label={`Open ${order.order_number}`}>
          <ChevronRight size={20} />
        </button>
      </header>

      <div className="order-card__status-row">
        <StatusPill status={order.status} label={orderMeta.label} type={tones.status || orderMeta.tone} size="sm" />
        <StatusPill status={order.payment_status} label={paymentMeta.label} type={tones.payment_status || paymentMeta.tone} size="sm" />
        <StatusPill status={order.fulfillment_status} label={fulfillMeta.label} type={tones.fulfillment_status || fulfillMeta.tone} size="sm" />
        <StatusPill status={order.delivery_status} label={deliveryMeta.label} type={tones.delivery_status || deliveryMeta.tone} size="sm" />
        <StatusPill status={order.priority} label={priorityMeta.label} type={tones.priority || priorityMeta.tone} size="sm" />
      </div>

      <dl className="order-card__metrics">
        <div><dt><DollarSign size={15} /> Total</dt><dd>{money(order.total_amount)}</dd></div>
        <div><dt><PackageCheck size={15} /> Items</dt><dd>{order.item_count || 0}</dd></div>
        <div><dt><CalendarClock size={15} /> Delivery</dt><dd>{order.scheduled_delivery_at ? dateText(order.scheduled_delivery_at) : order.requested_delivery_date || "Not scheduled"}</dd></div>
        <div><dt><MapPin size={15} /> City</dt><dd>{order.delivery_city_snapshot || "Not provided"}</dd></div>
      </dl>

      {(order.requires_manual_review || order.is_rush_order || order.coupon_code_snapshot) && (
        <footer className="order-card__flags">
          {order.requires_manual_review && <span>Manual review</span>}
          {order.is_rush_order && <span>Rush</span>}
          {order.coupon_code_snapshot && <span>{order.coupon_code_snapshot}</span>}
        </footer>
      )}
    </article>
  );
}
